import { servicesData } from '../../../mocks/services';

export default function Services() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Core Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            We embed fractional leaders and deployment experts directly into your organization. Unlike traditional agencies, our professionals become part of your team, working hands-on to build capabilities, transfer knowledge, and drive sustainable transformation from within.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-lg mb-6 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                {service.title}
              </h3>
              <p className="text-sm text-gray-700 mb-4 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <span className="text-sm text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-lg p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Ready to Embed Expert Leaders in Your Team?
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            Partner with Shock Growth Partners to access fractional leaders who work directly within your organization, building lasting capabilities and driving measurable results through hands-on execution.
          </p>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-white text-teal-600 text-base font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Start Your Growth Journey
          </button>
        </div>
      </div>
    </section>
  );
}
